export default function getFlightSearchReultsFactory(ajax, getSession) {
  return async function getFlightSearchResults({ query }) {
    return ajax({
      resource: 'flights/search',
      method: 'post',
      data: query,
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/getFlightSearchResults.js